<app-page-heading [key]="'reports.overview.page-title'"></app-page-heading>

<section class="container-fluid">
    <div class="m-b-md">
        <label for="select-report" [i18n]="[{target: 'innerHTML', key: 'reports.overview.select.label'}]"></label>
        <select id="select-report" class="form-control" [(ngModel)]="reportIdSelected">
            <option *ngFor="let report of reports" [ngValue]="report.powerBiId">{{report.name}}</option>
        </select>
    </div>
</section>

<app-power-bi-report *ngIf="reportIdSelected" [reportId]="reportIdSelected"></app-power-bi-report>
